import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import {
  latestStrategyGuideForContactQuery,
  strategyGuideVersionsForContactQuery,
  extractLatestStrategyGuideForContact,
  extractStrategyGuideVersionsForContact,
} from './constants';

export function useLatestStrategyGuide(contactId, skip = false) {
  const { data, loading, error, refetch } = useQuery(
    latestStrategyGuideForContactQuery,
    {
      variables: { contactId },
      skip: !contactId || skip,
      fetchPolicy: 'cache-and-network',
    },
  );

  const strategyGuide = useMemo(() => {
    return extractLatestStrategyGuideForContact(data);
  }, [data]);

  return { strategyGuide, loading, error, refetch };
}

export function useStrategyGuideVersions(contactId, skip = false) {
  const { data, loading, error, refetch } = useQuery(
    strategyGuideVersionsForContactQuery,
    {
      variables: { contactId },
      skip: !contactId || skip,
      fetchPolicy: 'cache-and-network',
    },
  );

  const versions = useMemo(() => {
    return extractStrategyGuideVersionsForContact(data) || [];
  }, [data]);

  return { versions, loading, error, refetch };
}
